import PropTypes from 'prop-types'

const propTypes = PropTypes.shape({
  id: PropTypes.number,
  type: PropTypes.string,
  data: PropTypes.shape({
    type: PropTypes.number,
    value: PropTypes.number,
    number: PropTypes.number,
  }),
  operand: PropTypes.string,
  description: PropTypes.string,
  number: PropTypes.number,
  verified: PropTypes.bool,
})

export default propTypes
